export const locale = {
  lang: 'es',
  data: {
    'HEADER': {
      'TITLE': 'Registros de conciliación',
    },
  }
};
